module.exports = __webpack_public_path__ + "img/sujit.4af58a3b.png";